export enum DetailsTabValue {
  Original = 0,
  Final,
  Compare,
}

export enum OptimizationStatus {
  Regular = 'Regular',
  SEO = 'SEO',
  GEO = 'GEO',
}

export enum CompareSource {
  Original = 0,
  SEO,
  GEO,
}

export enum PDPGenerationStatus {
  IDLE = 'IDLE',
  PDP_OPTIMIZATION_RUNNING = 'PDP_OPTIMIZATION_RUNNING',
  PDP_SEO_OPTIMIZATION_RUNNING = 'PDP_SEO_OPTIMIZATION_RUNNING',
  PDP_GEO_OPTIMIZATION_RUNNING = 'PDP_GEO_OPTIMIZATION_RUNNING',
  PRODUCT_TITLE_OPTIMIZATION_RUNNING = 'PRODUCT_TITLE_OPTIMIZATION_RUNNING',
  PRODUCT_DESCRIPTION_OPTIMIZATION_RUNNING = 'PRODUCT_DESCRIPTION_OPTIMIZATION_RUNNING',
  PRODUCT_FEATURES_OPTIMIZATION_RUNNING = 'PRODUCT_FEATURES_OPTIMIZATION_RUNNING',
}
